<!--基于v-charts和echarts的折线图-->
<template>
  <div class="chart">
    <ve-chart
      height="100%"
      :data="chartData"
      :settings="chartSettings"
      :extend="chartExtends"
      :loading="loading"
      :data-empty="data.length ? false : true"
    />
  </div>
</template>
<script>
export default {
  props: {
    columns: {
      type: Array,
      required: false,
      default: () => { return [] }
    },
    data: {
      type: Array,
      required: false,
      default: () => { return [] }
    },
    setting: {
      type: Object,
      required: false,
      default: () => { return {} }
    },
    extend: {
      type: Object,
      required: false,
      default: () => { return {} }
    },
    loading: Boolean,
    unit: {
      type: String,
      default: ''
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd hh:mm'
    }
  },
  data () {
    return {
      chartData: {
        columns: this.columns,
        rows: this.data
      }
    }
  },
  computed: {
    chartSettings () {
      const setting = this.setting || {}
      const o = {
        area: true
      }
      Object.assign(o, setting)
      return o
    },
    chartExtends () {
      const hexToRgba = (hex, opacity) => {
        let rgbaColor = ''
        const reg = /^#[\da-f]{6}$/i
        if (reg.test(hex)) {
          rgbaColor = `rgba(${parseInt('0x' + hex.slice(1, 3))},${parseInt(
            '0x' + hex.slice(3, 5)
          )},${parseInt('0x' + hex.slice(5, 7))},${opacity})`
        }
        return rgbaColor
      }
      const _this = this
      const extend = this.extend || {}
      const color = ['#7DC8B1', '#EDC68D', '#DC6170']
      const o = {
        color: color,
        legend: {
          textStyle: {
            color: '#f8f8f8'
          }
        },
        grid: {
          left: 40,
          right: 40,
          bottom: 20,
          top: 40
        },
        xAxis: {
          axisLabel: {
            color: '#f8f8f8',
            formatter: (value) => {
              return _this.$parseTime(value, this.format)
            }
          }
        },
        yAxis: {
          name: '(' + this.unit + ')',
          position: 'left',
          nameTextStyle: {
            color: '#f8f8f8'
          },
          axisLabel: {
            color: '#f8f8f8',
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              opacity: 0.3
            }
          }
        },
        tooltip: {
          formatter: (params) => {
            let html = ''
            html += _this.$parseTime(params[0].name, this.format)
            if (_this.setting.type === 'histogram') {
              html += `<div>
                        <span class="market-v"></span>
                        ${this.extend.title.text}量: ${(params[0].data + params[1].data).toFixed(1) + this.unit}
                    </div>
                    <hr class="line-hr">
                    `
            }
            for (let i = 0; i < params.length; i++) {
              let data
              if (_this.setting.type === 'line') {
                data = params[i].data[1]
              } else {
                data = params[i].data
              }
              html += `<div>
                        ${params[i].marker}
                        ${params[i].seriesName}: ${data + this.unit}
                    </div>`
              if (_this.setting.type === 'line' && i === 0) {
                html += `<hr class="line-hr" />`
              }
            }
            return html
          }
        },
        series (v) {
          if (v.length) {
            for (let i = 0; i < v.length; i++) {
              v[i].showSymbol = false
              if (_this.setting.type === 'line') {
                v[i].areaStyle.normal.color = {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: hexToRgba(color[i], 0.1)
                  }, {
                    offset: 0.5, color: hexToRgba(color[i], 0.1)
                  }],
                  global: false // 缺省为 false
                }
              } else {
                v[i].barWidth = 15
              }
            }
          }
          return v
        }
      }
      Object.assign(o, extend)
      return o
    }
  },
  watch: {
    data: {
      handler: function (val) {
        this.chartData.rows = val
      },
      deep: true // 对象内部的属性监听，也叫深度监听
    },
    columns (val) {
      this.chartData.columns = val
    }
  }
}
</script>
<style lang="stylus" scoped>
/deep/.v-charts-data-empty
  background-color: #1C2550
  color #1cc197
  font-size 16px
.chart
  height 100%
  width 100%
  & ::v-deep .v-charts-component-loading
    background-color transparent
</style>
<style lang="stylus">
.market-v
  display inline-block
  width 10px
  height 10px
  background-color red
  border-radius 50%
  margin-right 5px
.line-hr
  border-color rgba(255,255,255,0.35)
</style>
